import { Link } from 'react-router-dom';
import styles from './GroupTile.module.css';

export default function GroupTile({ to, imageUrl, name, className, children }) {
  const tile = (
    <div className={`${styles.tile}${className ? ` ${className}` : ''}`}>
      <div
        className={styles.image}
        style={imageUrl ? { backgroundImage: `url(${imageUrl})` } : undefined}
      >
        {children}
      </div>
      <div className={styles.name}>{name}</div>
    </div>
  );

  return to ? (
    <Link to={to} className={styles.link}>
      {tile}
    </Link>
  ) : (
    tile
  );
}
